import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SwUpdate } from '@angular/service-worker';
import { interval, fromEvent } from 'rxjs';

import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import { PushNotificationService } from './push-notification.service';
import { ADMIN_CONSTANT, AdminConfig } from './app.model';
import { AppService } from './app.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { CheckAdminPassComponent } from './shared/components/check-admin-pass/check-admin-pass.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Admission Portal Console';
  adminPass: any;

  constructor(
    private dialog: MatDialog,
    private swUpdate: SwUpdate,
    private service: AppService,
    private pushNotification: PushNotificationService
  ) { }

  ngOnInit(): void {
    // if (environment.finalRunMode) {
    //   this.detectDevToolsNew();
    // }
    this.checkOffline();
    this.checkForAppUpdate();
    this.pushNotification.pushMessagingControl(this.service);
    this.adminPass = this.service
      .getToken(ADMIN_CONSTANT.ADMIN_TOKEN_ADMIN_CONFIG)
      .find(
        (f: AdminConfig) =>
          f.ConfigCode === 'ADMIN_PASS'
      );
    if (this.adminPass.ConfigValue && !this.service.getToken('ADMIN_PASS_FLAG')) {
      // this.adminPass.ConfigValue;
      this.dialog
        .open(CheckAdminPassComponent, {
          width: '325px',
          position: { top: '10%' },
          disableClose: true,
          data: {
            adminPassValue: this.adminPass.ConfigValue
          },
        })
        .afterClosed()
        .subscribe((r) => {
          if (r === '200') {
            this.service.setToken('ADMIN_PASS_FLAG', true);
          }
        });
    }
  }

  checkOffline(): void {
    fromEvent(window, 'offline').subscribe((r) => {
      if (r.type === 'offline') {
        this.service.showToast(ADMIN_CONSTANT.OFFLINE_MESSAGE, '', 0);
      }
    });
    fromEvent(window, 'online').subscribe((r) => {
      if (r.type === 'online') {
        this.service.showToast(
          ADMIN_CONSTANT.ONLINE_MESSAGE,
          '',
          ADMIN_CONSTANT.TOAST_DURATION_MEDIUM
        );
      }
    });
  }

  checkForAppUpdate(): void {
    if (this.swUpdate.isEnabled) {
      // after every certain interval check for app update
      interval(6 * 60 * 60).subscribe(() => this.swUpdate.checkForUpdate());

      // for windows & mac
      // this.swUpdate.activateUpdate().then(() => window.location.reload());

      this.swUpdate.available.subscribe((res) => {
        this.service.showToast(`A newer verion is avilable!!`);
        this.dialog
          .open(ConfirmDialogComponent, {
            width: '325px',
            position: { top: '10%' },
            disableClose: true,
            data: {
              noCancel: true,
              header: 'Update available',
              message: 'A newer version of the app is available!',
            },
          })
          .afterClosed()
          .subscribe((r) => {
            if (!!r) {
              this.swUpdate.activateUpdate().then(() => {
                // console.log(`A newer verion is avilable!!`);
                window.location.reload();
              });
            }
          });
      });
      this.swUpdate.checkForUpdate();
    }
  }

  @HostListener('document:contextmenu', ['$event'])
  disableRightClick(event: MouseEvent) {
    if (environment.finalRunMode) {
      event.preventDefault();
    }
  }

  // @HostListener('document:keydown', ['$event'])
  // disableDevToolsShortcuts(event: KeyboardEvent) {
  //   // if (environment.production) {
  //   //   if (event.key === 'F12') {
  //   //     event.preventDefault();
  //   //   }
  //   //   if (event.ctrlKey && (event.key === 'I' || event.key === 'J' || event.key === 'U')) {
  //   //     event.preventDefault();
  //   //   }
  //   // }
  //   event.preventDefault();
  // }
  detectDevToolsNew() {
    let isDevToolsOpen = false;
    const checkDevTools = () => {
      const threshold = 150;
      const devToolsOpened =
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold;

      if (devToolsOpened && !isDevToolsOpen) {
        isDevToolsOpen = true;
        this.showDevToolsWarning(true);
      } else if (!devToolsOpened) {
        isDevToolsOpen = false;
      }
      requestAnimationFrame(checkDevTools);
    };
    window.addEventListener("keydown", (event) => {
      if (
        event.key === "F12" ||
        (event.ctrlKey && (event.key === "I" || event.key === "J" || event.key === "U"))
      ) {
        event.preventDefault();
        this.showDevToolsWarning();
      }
    });
    requestAnimationFrame(checkDevTools);
  }

  private showDevToolsWarning(reloadState?: boolean) {
    console.warn("Developer tools detected!");
    Swal.fire({
      title: "Developer tools are not allowed!",
      text: reloadState ? "Please close developer tools and click 'Reload'" : '',
      icon: "warning",
      confirmButtonColor: "#34c38f",
      confirmButtonText: reloadState ? "Reload" : "OK",
      allowOutsideClick: false
    }).then((result) => {
      if (result.value && reloadState) {
        this.service.onLogout()
      }
    });
  }
}
